import { useEffect } from 'react';

import { usePublishSpaPageViewed } from '@web-platform/shared-banana-tracking/src/funnelEvents/usePublishSpaPageViewed';
import { trackThirdPartyEvent } from '@web-platform/shared-banana-tracking/src/trackThirdParty/trackThirdPartyEvent';
import { PAGE_GROUPS } from '@web-platform/shared-universal-constants/src/pageGroups';
import { FEATURE_DECISION_KEYS } from '@web-platform/shared-universal-constants-config';
import { ANALYTICS_EVENTS } from '@web-platform/shared-universal-constants-tracking';
import { homepageLoaded } from '@web-platform/shared-universal-redux/src/actions/render';
import {
  getLocation,
  getTrustedFunnel,
  getUserIdentifiers,
} from '@web-platform/shared-universal-redux/src/state';
import { buildViewPageContext } from '@web-platform/shared-universal-tracking/src/funnelEvents/viewEvent';
import { getFeatureDecision } from '@web-platform/shared-universal-utils-frontend/src/config';
import { logOperationalEvent } from '@web-platform/shared-universal-utils-frontend/src/helpers/logger';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';

export const useHomepageTracking = () => {
  const dispatch = useDispatch();
  const publishSpaPageViewed = usePublishSpaPageViewed();
  const { currentScreenName: previousScreenName = '', viewGuid: viewReferrerId = '' } =
    useSelector(getTrustedFunnel);
  const { viewId: serverViewId } = useSelector(getUserIdentifiers);
  const { lastNavWasSoft } = useSelector(getLocation);

  const enableGoogleTagManager =
    getFeatureDecision(FEATURE_DECISION_KEYS.ENABLE_GOOGLE_TAG_MANAGER) &&
    getFeatureDecision(FEATURE_DECISION_KEYS.ENABLE_BANANA_GTM_INTEGRATION);

  useEffect(() => {
    const eventGuid = !lastNavWasSoft && serverViewId ? serverViewId : uuid();
    logOperationalEvent({
      eventName: ANALYTICS_EVENTS.FUNNEL.HOMEPAGE.NAME,
    });

    publishSpaPageViewed({
      previousName: previousScreenName,
      referrerId: viewReferrerId,
      viewGuid: eventGuid,
      requestId: eventGuid,
      pageContext: buildViewPageContext({
        analyticsPage: 'home',
        pageGroup: PAGE_GROUPS.HOME,
      }),
    });

    if (enableGoogleTagManager) {
      trackThirdPartyEvent('banana_homepage_loaded');
    }

    dispatch(homepageLoaded(viewReferrerId, previousScreenName, eventGuid));

    // SHIBA-391: Do not copy this, we only suppressed so we could quickly make this a blocking error in new hooks
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
};
